<template>
  <div>
    <div class="text-subtitle mb-4">Modifier le nom et date de l'épreuve, indiqués dans l'entête.</div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="evenement.nom" label="Nom de l'épreuve"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="evenement.date_debut" type="date" label="Date de début de l'épreuve"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="evenement.date_fin" type="date" label="Date de fin de l'épreuve"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary-dark" @click="update_config()" :loading="loading" class="mt-4" block>Enregistrer les
          modifications</v-btn>
      </v-col>
    </v-row>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">
      <hr />

      <div class="text-h6">Historique des modifications</div>
      <ConfigHistory v-if="evenement.id" action="config_evenement" :id="evenement.id" :key="lastFetch"></ConfigHistory>
    </div>
    <v-snackbar v-model="show_snackbar" location="top right" color="dark-green">
      Mise à jour effectuée avec succès !

      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="show_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import Evenement from "@/classes/Evenement/Evenement.class";
import ConfigHistory from "@/components/Administration/ConfigurationModule/ConfigHistory.vue";

export default {
  components: { ConfigHistory },
  data() {
    return {
      evenement: new Evenement(),
      loading: false,
      show_snackbar: false,
      lastFetch: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async update_config() {
      this.loading = true;
      await this.evenement.update_config();
      this.loading = false;
      this.show_snackbar = true;
      this.lastFetch = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  async mounted() {
    this.evenement.id = this.mainStore.module.evenement.id;
    await this.evenement.fetch();
  },
};
</script>

<style lang="sass" scoped>
</style>